<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('绑定类型')">
      <l-select
        v-model="data.bindingType"
        :placeholder="$t('请选择')"
        size="mini"
        :options="[
          { label: '关联组件', value: 1 },
          { label: '固定值', value: 2 },
        ]"
        @change="handleCodeTypeChange"
        :clearable="false"
      >
      </l-select>
    </el-form-item>
    <el-form-item
      :label="$t('关联组件')"
      v-if="['qrcode', 'barcode'].includes(data.type) && data.bindingType == 1"
    >
      <l-select
        v-model="data.valueKey"
        :placeholder="$t('请选择')"
        size="mini"
        :options="valueOptions"
        :clearable="false"
      >
      </l-select>
    </el-form-item>
    <el-form-item :label="$t('固定值')" v-if="data.bindingType==2">
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入内容"
        v-model="data.default"
      />
    </el-form-item>
    <el-form-item :label="$t('条码大小')">
      <el-input-number
        v-model="data.size"
        controls-position="right"
        :min="40"
      />
    </el-form-item>
    <el-form-item :label="$t('条码边距')">
      <el-input-number
        v-model="data.margin"
        controls-position="right"
        :min="0"
      />
    </el-form-item>
    <el-form-item :label="$t('条码颜色')">
      <l-input-color v-model="data.color" />
    </el-form-item>
    <el-form-item :label="$t('背景颜色')">
      <l-input-color v-model="data.background" />
    </el-form-item>
  </div>
</template>

<script>
import mixin from '../../../mixin'
export default {
    name: "config-qrcode",
    mixins: [mixin()],
    inject: ["formDesign"],
    props: ['data'],
    data () {
        return{}
    },
    created(){
        
    },
    computed: {
    valueOptions() {
      const res = [];
      const formInfo = this.formDesign.toSaveData();
      if (!this.data.subfield) {
        formInfo.tabList.forEach((tab) => {
          tab.components.forEach((com) => {
            if (
              !["divider", "gridtable", "card", "btn", "qrcode", "barcode", "tableLayout", 'txt', 'img'].includes(com.type) &&
              com.prop != this.data.prop
            ) {
              res.push({ value: com.prop, label: com.label });
            }
          });
        });
      } else {
        formInfo.tabList.forEach((tab) => {
          tab.components.forEach((com) => {
            if (
              ["gridtable"].includes(com.type) &&
              com.children.findIndex((t) => t.prop == this.data.prop) != -1
            ) {
              com.children.forEach((c) => {
                if (c.prop != this.data.prop) {
                  res.push({ value: c.prop, label: c.label });
                }
              });
            }
          });
        });
      }
      return res;
    },
  },
  methods: {
    handleCodeTypeChange(val) {
      if (!val) return;
      this.data.default = "";
    },
  },
}
</script>

